import { httpClient } from '@/core/api/http-client'
import type { PermissionInfo } from '@/domain/entities/permission.entity'
import type { PermissionRepository } from '@/domain/repositories/permission.repository'
import { unwrapList } from '@/infrastructure/shared/unwrap'
import type { PermissionInfoDto } from './permission.dto'
import { permissionMapper } from './permission.mapper'

export class PermissionHttpRepository implements PermissionRepository {
  async list(): Promise<PermissionInfo[]> {
    const raw = await httpClient.get<unknown>('/permissions')
    return unwrapList<PermissionInfoDto>(raw).map(permissionMapper.toPermission)
  }
}
